import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "../Services/Card";
import moment from "moment";
import DataTable from "react-data-table-component";

const CardPriceList = () => {
  const [amount, setAmount] = useState("");
  const [error, setError] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [type, setType] = useState("");
  const [cardList, setCardList] = useState([]);
  const [id, setId] = useState([]);
  const [createdDate, setCreatedDate] = useState("");
  const [status, setStatus] = useState("");
  const perPage = 10;

  useEffect(() => {
    getCardList();
  }, [currentPage]);

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (value.trim()) {
      setError((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[fieldName];
        return updatedErrors;
      });
    }
    switch (fieldName) {
      case "amount":
        setAmount(value);
        break;
      case "type":
        setType(value);
        break;
      default:
        break;
    }
  };

  const getCardList = async () => {
    try {
      const response = await API.getCardData("");
      setCardList(response?.data?.data || []);
    } catch (error) {
      toast.dismiss();
      if (!error.response) toast.error("Network error!");
      
      else if (error.response.status === 403) {
        window.location.replace("/Login");
        toast.error("Session expired!");
      } else 
        {
          toast.error(error?.response?.data.message)
          // console.log('error.response',error?.response?.data.message);
        };
    }
  };

  const handleGetData = async (Id) => {
    try {
      const response = await API.getCardData(`?id=${Id}`);
      const fetchedData = response?.data?.data[0];
      if (fetchedData) {
        setId(fetchedData.id);
        setAmount(fetchedData?.price);
        setType(fetchedData?.type);
        setCreatedDate(fetchedData?.created_At);
        setStatus(fetchedData?.is_active);
      } else toast.error("Failed to get card details.");
    } catch (error) {
      if (error.response?.status === 404) toast.error("Resource not found");
      else if (error.response?.status === 403)
        window.location.replace("/Login");
    }
  };

  const updateCardPriceData = async () => {
    try {
      const payload = { type, price: amount };
      const response = await API.updateCardData(id, payload);
      if (response?.status === 200) {
        toast.success(response?.data?.message);
        getCardList();
        setTimeout(() => window.location.reload(), 2000);
      } else toast.error(response?.data?.message || "Failed to update card");
    } catch (error) {
      toast.error("Unexpected error updating card.");
    }
  };

  const handleCancel = () => {
    setId("");
    setAmount("");
    setType("");
  };

  const columns = [
    { name: "SrNo", selector: (row, index) => index + 1, sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div
          className="navbar-menu-wrapper d-flex align-items-stretch"
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <ul className="navbar-nav navbar-nav-right">
            <li className="nav-item nav-profile1">
              <span
                className="nav-link mdi mdi-menu"
                style={{
                  width: "50px",
                  fontSize: "24px",
                  color: "black",
                  cursor: "pointer",
                }}
                id={`actionDropdown-${row.id}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              ></span>
              <div
                className="dropdown-menu navbar-dropdown"
                aria-labelledby={`actionDropdown-${row.id}`}
              >
                <a className="dropdown-item">
                  <button
                    onClick={() => handleGetData(row.id)}
                    className="btn btn-success btn-sm"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#myModalViewDiscount"
                  >
                    View
                  </button>
                </a>
                <div className="dropdown-divider"></div>
                <a className="dropdown-item">
                  <button
                    onClick={() => handleGetData(row.id)}
                    className="btn btn-primary btn-sm"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#myModal"
                  >
                    Edit
                  </button>
                </a>
                {/* Uncomment if you need Activate/Deactivate toggle
                <div className="dropdown-divider"></div>
                <a className="dropdown-item">
                  <button
                    className={`btn btn-sm w-100 ${
                      row.is_active ? "btn-secondary" : "btn-info"
                    }`}
                    onClick={() => changeStatus(row.id, row.is_active)}
                  >
                    {row.is_active ? "De-Activate" : "Activate"}
                  </button>
                </a> */}
              </div>
            </li>
          </ul>
        </div>
      ),
    },
    { name: "Card Amount", selector: (row) => row.price, sortable: true },
    {
      name: "Type",
      selector: (row) =>
        row.type === "new_card" ? "New Card" : "Reissue Card",
    },
    {
  name: "Status",selector: (row) => row.is_active ? "Active" : "De-Activated", sortable: true },
    {
      name: "Created Date",
      selector: (row) => moment(row.created_At).format("DD-MM-YYYY"),
      sortable: true,
    },
  ];

  const customTableStyles = {
    headCells: {
      style: {
        fontWeight: "600",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
        color: "#333",
        borderBottom: "1px solid #dee2e6",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        paddingTop: "12px",
        paddingBottom: "12px",
      },
    },
    rows: {
      style: {
        minHeight: "52px",
        "&:hover": {
          backgroundColor: "#f1f5f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #dee2e6",
        paddingTop: "10px",
      },
    },
  };

  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Added Card Price</h4>
          </div>
          <div className="card-body">
            <DataTable
              columns={columns}
              data={cardList}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={customTableStyles}
            />
          </div>
        </div>

        {/* Modal View */}
        <div className="modal" id="myModalViewDiscount">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Card Price Details</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered border-secondary">
                  <thead>
                    <tr>
                      <th>Card Amount</th>
                      <th>Type</th>
                    </tr>
                    <tr>
                      <td>{amount}</td>
                      <td>{type}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <th>Created Date</th>
                    </tr>
                    <tr>
                      <td>{status ? "Active" : "De-Activated"}</td>
                      <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Modal Edit */}
        <div className="modal fade" id="myModal" data-bs-backdrop="static">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Card Price</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Card Amount <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Amount"
                        value={amount}
                        onChange={(e) => handleFieldChange(e, "amount")}
                      />
                      {error?.amount && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {error.amount}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Type <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className="form-select"
                        value={type}
                        disabled
                        onChange={(e) => handleFieldChange(e, "type")}
                      >
                        <option value="">Select Type</option>
                        <option value="new_card">New Card</option>
                        <option value="reIssuecard">Re Issue Card</option>
                      </select>
                      {error?.type && (
                        <span
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {error.type}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-4">
                  <button
                    className="btn btn-primary"
                    onClick={updateCardPriceData}
                  >
                    Update
                  </button>
                  <button
                    onClick={handleCancel}
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </div>
  );
};

export default CardPriceList;

